import SectionTitle from "./common/SectionTitle";

const About = ({ titleHead = false }) => {
	return (
		<section className="about">
			<div className="container">
				<div className="about-image">
					<img
						src="./assets/images/about-us.webp"
						alt="About Trivnet Services"
						className=""
						loading="lazy"
					/>
				</div>
				<div className="about-content">
					{titleHead && (
						<SectionTitle
							title="About Trivnet Services"
							subtitle="Your trusted technology partner"
							align="left"
						/>
					)}

					<p>
						Founded in 2010, Trivnet Services Limited has grown to become a
						leading provider of innovative IT solutions. Our team of experts is
						dedicated to delivering exceptional service and cutting-edge
						technology to businesses of all sizes.
					</p>

					<div className="about-stats">
						<div className="stat">
							<h3>12+</h3>
							<p>Years Experience</p>
						</div>
						<div className="stat">
							<h3>250+</h3>
							<p>Happy Clients</p>
						</div>
						<div className="stat">
							<h3>50+</h3>
							<p>Projects Completed</p>
						</div>
					</div>

					<ul className="about-features">
						<li>
							<i className="fas fa-check-circle"></i>
							Certified professionals
						</li>
						<li>
							<i className="fas fa-check-circle"></i>
							24/7 support
						</li>
						<li>
							<i className="fas fa-check-circle"></i>
							Custom solutions
						</li>
					</ul>
				</div>
			</div>
		</section>
	);
};

export default About;
